/**
 * getNotifications.js
 * Written by: Alex Kasemir
 */

import request from 'store/request/actions';
import event from 'utils/event';

export const GET_NOTIFICATIONS_START = `GET_NOTIFICATIONS_START`;
export const GET_NOTIFICATIONS_SUCCESS = `GET_NOTIFICATIONS_SUCCESS`;
export const GET_NOTIFICATIONS_FAILURE = `GET_NOTIFICATIONS_FAILURE`;

export const getNotificationsStart = () => ({
  type: GET_NOTIFICATIONS_START,
});

export const getNotificationsSuccess = ({ results, count, next }) => ({
  type: GET_NOTIFICATIONS_SUCCESS,
  results,
  count,
  next,
});

export const getNotificationsFailure = (error) => ({
  type: GET_NOTIFICATIONS_FAILURE,
  error,
});

/**
 * Description of the getNotifications action
 */
export const getNotifications = () => {
  return (dispatch) => {
    dispatch(getNotificationsStart());
    return dispatch(request(`/notifications/`, `GET`))
      .then((response) => {
        dispatch(getNotificationsSuccess(response.data));
      })
      .catch((error) => {
        event(`error-notifications`, [`error`, `get-notifications`]);
        dispatch(getNotificationsFailure(error));
      });
  };
};
